import { ApiService } from "./api.service";
export default class WeatherForecastService extends ApiService {
  namespace = "WeatherForecast";
  template = "weahterTemplate";
  DOMAIN = 25;
  icon = "BlockWithSun";
  name = "WeatherForecast";
  constructor() {
    super("weather");
  }
}
